import { render, staticRenderFns } from "./visualizadores_adicionales_list.vue?vue&type=template&id=5ad84e3b&scoped=true"
import script from "./visualizadores_adicionales_list.vue?vue&type=script&lang=js"
export * from "./visualizadores_adicionales_list.vue?vue&type=script&lang=js"
import style0 from "./visualizadores_adicionales_list.vue?vue&type=style&index=0&id=5ad84e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad84e3b",
  null
  
)

export default component.exports